import { FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES } from 'constants/flight'

const SESSION_EXPIRY_MS = FLIGHTS_SESSION_EXPIRATION_TIME_IN_MINUTES * 60 * 1000
const MAX_CACHE_SIZE = 50

export interface ShortlistedJourneyCacheEntry {
  journey: App.JourneyV2
  searchId?: string
  sessionId?: string
  cachedAt: number
}

const cache = new Map<string, ShortlistedJourneyCacheEntry>()

function evictExpired() {
  const now = Date.now()
  for (const [key, entry] of cache) {
    if (now - entry.cachedAt > SESSION_EXPIRY_MS) {
      cache.delete(key)
    }
  }
}

export function cacheShortlistedJourneys(
  journeys: Array<App.JourneyV2>,
  searchId?: string,
  sessionId?: string,
) {
  evictExpired()

  const cachedAt = Date.now()
  for (const journey of journeys) {
    const journeyKey = journey.bookingInfo?.journeyKey
    if (!journeyKey) continue

    if (cache.size >= MAX_CACHE_SIZE && !cache.has(journeyKey)) {
      const oldestKey = [...cache.entries()].sort(([, a], [, b]) => a.cachedAt - b.cachedAt)[0]?.[0]
      if (oldestKey) cache.delete(oldestKey)
    }

    cache.set(journeyKey, { journey, searchId, sessionId, cachedAt })
  }
}

export function getCachedJourney(journeyKey: string): ShortlistedJourneyCacheEntry | undefined {
  const entry = cache.get(journeyKey)
  if (!entry) return undefined
  if (Date.now() - entry.cachedAt > SESSION_EXPIRY_MS) {
    cache.delete(journeyKey)
    return undefined
  }
  return entry
}
